<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :span="22" :offset="1"  class="page-title">Report</el-col>
      <el-col :span="22" :offset="1" class="hight-btn" >
        <el-table :data="tableData">
          <el-table-column prop="name">
            <template slot-scope="scope">
              <p>{{scope.row.name}}</p>
            </template>
          </el-table-column>
          <el-table-column >
            <template slot-scope="scope">
              <el-button @click="exportTableData(scope.row.type)">Export</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import { exportLoginInfo, exportVendorAssessment } from '@/services/report.service';
import CommonHelper from '@/utils/commonHelper';

export default {
  components: {
    Footer,
    Header
  },
  data () {
    return {
      tableData: [{
        name: 'Login Info Report',
        type: 'Login'
      }, {
        name: 'Vendor Assessment Result Report',
        type: 'vendorAssessment'
      }]
    }
  },
  methods: {
    async exportTableData (type) {
      this.$loading({fullscreen: true});
      let dataList;
      if (type === 'Login') {
        dataList = await exportLoginInfo();
        this.exportLogin(dataList);
      } else {
        dataList = await exportVendorAssessment();
        this.exportVendorAssessment(dataList);
      }
      this.$loading({fullscreen: true}).close();
    },
    exportLogin (dataList) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require('@/utils/Export2Excel');
        let tHeader = ['Display Name', 'Login Time', 'IP Address'];
        let filterVal = ['displayName', 'loginTime', 'ipAddress'];
        let sheet = [];
        // deep clone
        let exportLoginList = JSON.parse(JSON.stringify(dataList.data));
        // format data in key-value
        exportLoginList.forEach(item => {
          let row = [];
          row[filterVal[0]] = item.displayName;
          row[filterVal[1]] = CommonHelper.formatDate(item.loginTime);
          row[filterVal[2]] = item.ipAddress;
          sheet.push(row);
        });
        let data = this.formatJson(filterVal, sheet);
        exportJsonToExcel(tHeader, data, 'LoginInfoList');
      });
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    exportVendorAssessment (dataList) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require('@/utils/Export2Excel');
        let tHeader = [' ASSESSMENT LINK', 'VENDOR CODE', 'VENDOR NAME ', 'CONTACT PERSON', 'Vendor Email', 'Category',
          'REGION', 'Associated Staff', 'COMPANY', 'Active', 'STATUS'];
        let filterVal = ['assessmentLink', 'vendorCode', 'vendorName ', 'contactPerson', 'vendorEemail', 'category',
          'region', 'associatedStaff', 'company', 'active', 'status'];
        let sheet = [];
        // deep clone
        let exportLoginList = JSON.parse(JSON.stringify(dataList.data));
        // format data in key-value
        exportLoginList.forEach(item => {
          let row = [];
          row[filterVal[0]] = item[0];
          row[filterVal[1]] = item[1];
          row[filterVal[2]] = item[2];
          row[filterVal[3]] = item[3];
          row[filterVal[4]] = item[4];
          row[filterVal[5]] = item[5];
          row[filterVal[6]] = item[6];
          row[filterVal[7]] = item[7];
          row[filterVal[8]] = item[8];
          row[filterVal[9]] = item[9];
          row[filterVal[10]] = item[10];
          sheet.push(row);
        });
        let data = this.formatJson(filterVal, sheet);
        exportJsonToExcel(tHeader, data, 'VendorAssessmentResultList');
      });
    }
  }
};
</script>

<style scoped>
  .hight-btn{
    padding: 30px 0 15px 0;
  }
  .text-align-left {
    text-align: left;
  }

  .page-title{
    font-size: 20px;
    margin-top: 80px;
  }
  .margin-top{
    margin-top: 30px;
  }
  .line {
    width: 1px;
    height: 700px;
    background-color: #e6e6e6;
    margin-left: 20px;
  }

  .stakeholder-category-table{
    margin-top: 15px;
  }

  .table-nav{
    position: fixed;
    bottom: 40px;
  }
  /*rewrite element-ui */
  >>>.dialog-form .el-input{
    width: 360px;
  }
  >>>.el-dialog__body{
    padding: 5px 70px;
  }
  >>>.el-dialog__footer {
    padding: 40px 70px 20px;
  }
  >>>.el-button{
    border-color: #5e89ed;
    color: #5e89ed;
  }

  >>>.el-button:hover{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button:focus{
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger{
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus{
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-table{
    color: black;
  }

  >>>.el-table thead{
    color: black;
  }

  >>>.el-form--label-top .el-form-item__label{
    padding: 0;
  }

  >>>.el-form-item{
    margin-bottom: 5px;
  }

  >>>.el-pager li.active{
    color: #5e89ed;
  }

  >>>.el-pager li:hover{
    color: #5e89ed;
  }

  >>>.el-checkbox__inner{
    border: 1px solid #aaaaaa;
  }

  >>>.el-form-item__label{
    line-height: 32px;
  }

  .el-input {
    margin-top: 0;
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ReportMaintenance.vue